export default __webpack_public_path__ + "static/media/ic-company-shares.778885f4.svg";